export default __webpack_public_path__ + "static/media/udaf-logo.f20ecf06.png";